import { render, staticRenderFns } from "./my-qrcode.vue?vue&type=template&id=f60cf970&scoped=true&"
import script from "./my-qrcode.vue?vue&type=script&lang=js&"
export * from "./my-qrcode.vue?vue&type=script&lang=js&"
import style0 from "./my-qrcode.vue?vue&type=style&index=0&id=f60cf970&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60cf970",
  null
  
)

export default component.exports